<template>
  <div>
    <loading-cube v-if="loading"/>
    <validation-observer ref="observer" v-slot="{ validate }">
      <form v-if="timesheet !== null" @submit.prevent="(e) => submitForm(e, validate)">
        <checkbox_input
            v-model="timesheet.submitted"
            :disabled="true"
            class="switch"
            label="Submitted"
            name="no_name1"
        />

        <div class="timesheet_forms">
          <label>Timesheets</label>
          <div
              v-if="!isGeoAllZero(timesheet.geo) && !timesheet.submitted"
              style="margin-left: 200px;"
          >
            <button
                class="geo_button btn orcaBtn"
                type="button"
                @click="()=>applyGeoToPayments(timesheet)"
                style="max-width: 600px;"
            >
              Update from Geo
            </button>
          </div>

          <div class="timesheet_days_container">
            <div v-for="(item, index) in timesheet.payments" :key="item.id" class="timesheet_form">
              <label>{{ item.pay_date }} ({{ item.pay_weekday }})</label>
              <div class="payday_form_container">
                <validation-provider
                    v-slot="{ errors }"
                    :name="`${timesheet.payments[index].pay_date}`"
                    rules="payday_required|absolute_numeric_strict"
                >
                  <payday_input
                      v-model="timesheet.payments[index]"
                      :disabled="timesheet.submitted"
                      :rowIndex="index"
                      :timesheetId="timesheet.id"
                      @advanceFocus="handleAdvanceFocus"
                      @validate="() => validateRow(index)"
                  />
                  <span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
                </validation-provider>

                <!--<table v-if="showAdminDetails() && timesheet.payments[index].absence_type == null && timesheet.payments[index].amount > 0">-->
                <!--  <tr>-->
                <!--    <td>{{ timesheet.payments[index].price }} x {{ timesheet.rate.pay_amount }}</td>-->
                <!--    <td>£{{ timesheet.payments[index].amount * timesheet.rate.pay_amount }}</td>-->
                <!--  </tr>-->
                <!--</table>-->
              </div>
            </div>
          </div>
        </div>

        <checkbox_input
            ref="retentionCheckbox"
            v-model="timesheet.retention_released"
            :disabled="timesheet.submitted"
            class="switch"
            label="Retention Released"
            name="retention_releaased"
            @keydown.native="handleGenericKeydown"
        />

        <checkbox_input
            ref="backNextCheckbox"
            v-model="timesheet.back_next_week"
            :disabled="timesheet.submitted"
            class="switch"
            label="Back next week?"
            name="back_next_week"
            @keydown.native="handleGenericKeydown"
        />

        <!-- Repeaters: use forward/back aware focus helpers -->
        <addition_deductions_repeater_input
            ref="pre_additions"
            v-model="pre_additions"
            :descriptions="ms_opts.pre_additions"
            :disabled="timesheet.submitted"
            label="Pre-additions"
            name="pre_additions"
            @advance="() => focusTargetForward('post_additions')"
            @retreat="() => focusTargetBack('backNextCheckbox')"
        />

        <addition_deductions_repeater_input
            ref="post_additions"
            v-model="post_additions"
            :descriptions="ms_opts.post_additions"
            :disabled="timesheet.submitted"
            label="Post-additions"
            name="post_additions"
            @advance="() => focusTargetForward('pre_deductions')"
            @retreat="() => focusTargetBack('pre_additions')"
        />

        <addition_deductions_repeater_input
            ref="pre_deductions"
            v-model="pre_deductions"
            :descriptions="ms_opts.pre_deductions"
            :disabled="timesheet.submitted"
            label="Pre-deductions"
            name="pre_deductions"
            @advance="() => focusTargetForward('post_deductions')"
            @retreat="() => focusTargetBack('post_additions')"
        />

        <addition_deductions_repeater_input
            ref="post_deductions"
            v-model="post_deductions"
            :descriptions="ms_opts.post_deductions"
            :disabled="timesheet.submitted"
            label="Post-deductions"
            name="post_deductions"
            @advance="() => focusTargetForward('descriptions')"
            @retreat="() => focusTargetBack('pre_deductions')"
        />

        <payment_descriptions_editor
            ref="descriptions"
            v-model="descriptions"
            :payments="timesheet.payments"
            :disabled="timesheet.submitted"
            label="Descriptions"
            name="descriptions"
            @advance="() => focusTargetForward('submitButton')"
            @retreat="() => focusTargetBack('post_deductions')"
        />

        <div v-if="!timesheet.submitted" class="submit_buttons">
          <button
              ref="submitButton"
              :disabled="saving"
              class="btn orcaBtn"
              name="save_for_later"
              type="submit"
              @keydown="handleGenericKeydown"
          >
            <span v-if="!saving">Save</span>
            <span v-if="saving">Saving... <i class="fas fa-spinner fa-spin"></i></span>
          </button>

          <button
              ref="finaliseButton"
              :disabled="saving"
              class="btn orcaBtn"
              name="submit"
              type="submit"
              @keydown="handleGenericKeydown"
          >
            <span v-if="!saving">Finalise</span>
            <span v-if="saving">Saving... <i class="fas fa-spinner fa-spin"></i></span>
          </button>
        </div>

        <div class="back_button">
          <router-link
              :to="{ name: 'a_timesheet_r2_select_site_worker', query: { timesheet: timesheet_id}, params: { company_id, start_date, end_date, order_id, order_job_id } }">
            <button
                ref="backButton"
                :disabled="saving"
                class="btn orcaBtn"
                name="back"
                style="width: 100%"
                type="button"
                @keydown="handleGenericKeydown"
            >
              <span v-if="!saving && timesheet.submitted">Back</span>
              <span v-if="!saving && !timesheet.submitted">Back</span>
              <span v-if="saving">Saving... <i class="fas fa-spinner fa-spin"></i></span>
            </button>
          </router-link>
        </div>
      </form>
    </validation-observer>
  </div>
</template>

<style lang="scss" scoped>
.payday_form_container { display: grid; grid-template-columns: auto auto; overflow-x: auto; }

form { display: grid; grid-template-columns: 100%; grid-row-gap: 1em; }
.timesheet_days_container { margin-top: 0; }
.timesheet_forms { display: grid; grid-template-columns: auto; grid-row-gap: 1em; margin-bottom: 1em; }
.timesheet_form { min-width: 350px; display: grid; grid-template-columns: auto; grid-row-gap: 1em; margin-bottom: 1em; }
.timesheet_forms > label { padding: 0; margin: 0; align-content: center; font-weight: bold; }
.timesheet_form > label { padding: 0; margin: 0; align-content: center; }

@media(min-width: 1060px) {
  .timesheet_days_container { margin-top: 1em; }
  .timesheet_form { grid-template-columns: 200px auto; }
}

.submit_buttons {
  padding-left: 200px;
  margin-top: 4em;
  display: grid;
  grid-template-columns: 300px 300px;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  justify-content: flex-start;
  align-content: center;
  button { width: 100%; margin-right: 10px; }
}

.back_button {
  padding-left: 200px;
  width: 100%;
  display: grid;
  grid-template-columns: 600px;
  padding-top: 2em;
  justify-content: flex-start;
  align-content: center;
}

@media (max-width: 600px) {
  .submit_buttons { grid-template-columns: 1fr; }
  .back_button { width: 300px; grid-template-columns: 100%; }
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #e6007e !important;
  border-color: #e6007e !important;
}
</style>

<script>
import loadingCube from 'loaders/generic_record_loader.vue';
import PaydayInputVertical from 'pages/sunset/timesheets/components/timesheet_edit_timesheet/payday_input_vertical.vue';
import addition_deductions_repeater_input from 'pages/sunset/timesheets/components/timesheet_edit_timesheet/addition_deductions_repeater_input.vue';
import checkbox_input from 'pages/sunset/timesheets/components/timesheet_edit_timesheet/toggle_checkbox.vue';
import Payment_descriptions_editor
  from "pages/sunset/timesheets/components/timesheet_edit_timesheet/payment_descriptions_editor.vue";

export default {
  components: {
    Payment_descriptions_editor,
    loadingCube,
    payday_input: PaydayInputVertical,
    checkbox_input,
    addition_deductions_repeater_input
  },
  props: {
    company_id: { required: true },
    start_date: { required: true },
    end_date: { required: true },
    order_id: { required: true },
    order_job_id: { required: true },
    timesheet_id: { required: true }
  },
  data() {
    return {
      period: this.end_date,
      ms_opts: {},
      saving: false,
      loading: false,
      error: null,
      timesheet: null,
      workerData: null,
      descriptions: [],
      pre_additions: [],
      post_additions: [],
      pre_deductions: [],
      post_deductions: []
    };
  },
  async beforeMount() {
    await this.init();
  },
  methods: {
    async fetchAdditionsAndDeductions() {
      const [pre_additions, post_additions, pre_deductions, post_deductions] = await Promise.all([
        axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_additions/company'), //29
        axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_additions/company'), //30
        axios.get(this.crmApiPath + 'crm/attributes/ts_pre_tax_deductions/company'), //31
        axios.get(this.crmApiPath + 'crm/attributes/ts_post_tax_deductions/company') //32
      ]);
      this.ms_opts.pre_additions = pre_additions.data;
      this.ms_opts.post_additions = post_additions.data;
      this.ms_opts.pre_deductions = pre_deductions.data;
      this.ms_opts.post_deductions = post_deductions.data;
    },

    async init() {
      this.loading = true;
      await this.fetchAdditionsAndDeductions();
      await this.fetchTimesheet();

      this.timesheet.additions_deductions.forEach((item) => {
        switch (item.add_ded_type_id) {
          case 29: this.pre_additions.push(item); break;
          case 30: this.post_additions.push(item); break;
          case 31: this.pre_deductions.push(item); break;
          case 32: this.post_deductions.push(item); break;
        }
      });

      this.loading = false;
    },

    applyGeoToPayments(timesheet) {
      if (!Array.isArray(timesheet.geo) || !Array.isArray(timesheet.payments)) return timesheet;
      timesheet.payments.forEach((payment, index) => {
        payment.amount = timesheet.geo[index] ?? 0;
      });
      this.selected_timesheet = { ...timesheet };
      return timesheet;
    },
    isGeoAllZero(geo) {
      return Array.isArray(geo) && geo.every(val => val === 0);
    },
    async fetchTimesheet() {
      const { data } = await axios.get(
          `${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/timesheets/${this.timesheet_id}`
      );

      this.timesheet = data.data;

      this.descriptions = (this.timesheet.payments || [])
          .flatMap(p =>
              (p.descriptions || [])
                  .filter(d => d && (d.description || '').trim() !== '')
                  .map(d => ({
                    id: d.id ?? null,
                    payment_id: p.id,
                    description: d.description.trim()
                  }))
          );
    },

    // ---------- DOM helpers ----------
    isInside(el, comp) {
      const root = comp && (comp.$el || comp);
      return !!(root && el && root.nodeType === 1 && root.contains(el));
    },
    repeaterForEl(el) {
      const reps = [
        this.$refs.pre_additions,
        this.$refs.post_additions,
        this.$refs.pre_deductions,
        this.$refs.post_deductions
      ].filter(Boolean);
      return reps.find(r => this.isInside(el, r)) || null;
    },
    _repDeleteButtons(rep) {
      const root = rep && (rep.$el || rep);
      return root ? Array.from(root.querySelectorAll('.del_button')) : [];
    },

    // ---------- Focus helpers ----------
    focusDay(timesheetId, idx) {
      const selector = `#payment_${timesheetId}_${idx}`;
      const el = document.querySelector(selector);
      if (!el) return false;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus();
      try { el.select(); } catch (_) {}
      return true;
    },
    firstFocusableIn(refComp) {
      const root = refComp && (refComp.$el || refComp);
      if (!root) return null;
      return root.querySelector('input, button, [tabindex]:not([tabindex="-1"])');
    },
    getFocusOrder() {
      const items = [];
      if (!this.timesheet) return items;

      // day inputs in order
      const dayInputs = Array.from(
          document.querySelectorAll(`[id^="payment_${this.timesheet.id}_"]`)
      ).filter(el => !el.disabled);
      items.push(...dayInputs);

      // checkboxes
      const retention = this.firstFocusableIn(this.$refs.retentionCheckbox);
      const backNext = this.firstFocusableIn(this.$refs.backNextCheckbox);
      if (retention) items.push(retention);
      if (backNext) items.push(backNext);

      // repeaters – include a representative focusable so the order is stable
      const reps = [
        this.$refs.pre_additions,
        this.$refs.post_additions,
        this.$refs.pre_deductions,
        this.$refs.post_deductions
      ].filter(Boolean);
      reps.forEach(r => {
        const first = this.firstFocusableIn(r);
        if (first) items.push(first);
      });

      // action buttons
      if (this.$refs.submitButton) items.push(this.$refs.submitButton);
      if (this.$refs.finaliseButton) items.push(this.$refs.finaliseButton);
      if (this.$refs.backButton) items.push(this.$refs.backButton);

      return items;
    },

    // Enter a repeater forward: FIRST ✕ if any, else Amount
    focusTargetForward(refName) {
      this.$nextTick(() => {
        const rep = this.$refs[refName];
        if (!rep) return this.focusTarget(refName);
        const btns = this._repDeleteButtons(rep);
        if (btns.length) {
          const b = btns[0];
          b.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
          b.focus?.();
          return;
        }

        if (rep.focusFirstInput) {
          rep.focusFirstInput();
          return;
        }

        // brute fallback
        this.focusTarget(refName);
      });
    },

    // Enter a repeater backward: LAST ✕ if any, else Amount
    focusTargetBack(refName) {
      this.$nextTick(() => {
        const ref = this.$refs[refName];
        if (!ref) return;

        // If it's a repeater component
        const btns = this._repDeleteButtons(ref);
        if (btns.length) {
          const b = btns[btns.length - 1];
          b.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
          b.focus?.();
          return;
        }
        if (ref.focusLastDelete) { ref.focusLastDelete(); return; } // child helper if available

        if (ref.focusFirstInput) {
          ref.focusFirstInput();
          return;
        }

        // Fallback to first focusable in that section/ref
        this.focusTarget(refName);
      });
    },

    // Generic focus (first focusable descendant)
    focusTarget(refName) {
      this.$nextTick(() => {
        const ref = this.$refs[refName];
        const el = ref?.$el || ref;
        if (!el) return;

        const isFocusable = el.matches?.('input, button, [tabindex]:not([tabindex="-1"])');
        const focusable = isFocusable ? el : el.querySelector?.('input, button, [tabindex]:not([tabindex="-1"])');

        (focusable || el)?.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
        (focusable || el)?.focus?.();
        if (focusable?.select) {
          try { focusable.select(); } catch (_) {}
        }
      });
    },

    // Ordered navigation across the whole form
    navigate(direction) {
      const items = this.getFocusOrder();
      if (!items.length) return;

      const active = document.activeElement;
      let idx = items.indexOf(active);

      if (idx === -1) {
        const focusedDay = document.querySelector('.timesheet_days_container input:focus');
        if (focusedDay) idx = items.indexOf(focusedDay);
      }
      if (idx === -1) idx = 0;

      let nextIdx = idx + direction;
      if (nextIdx < 0) nextIdx = 0;
      if (nextIdx >= items.length) nextIdx = items.length - 1;

      const target = items[nextIdx];

      // If target lies inside a repeater, enter it based on direction
      const rep = this.repeaterForEl(target);
      if (rep) {
        if (direction === 1) {
          const btns = this._repDeleteButtons(rep);
          if (btns.length) { btns[0]?.focus?.(); return; }
          rep.focusFirstInput?.();
          return;
        } else {
          const btns = this._repDeleteButtons(rep);
          if (btns.length) { btns[btns.length - 1]?.focus?.(); return; }
          rep.focusFirstInput?.();
          return;
        }
      }

      // Default focusing for non-repeater targets
      target.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
      target.focus?.();
      if (target.tagName === 'INPUT' && target.type !== 'checkbox') {
        try { target.select(); } catch (_) {}
      }
    },

    // Boundary notifications from per-day input/buttons
    handleAdvanceFocus({ timesheetId, rowIndex, direction }) {
      const total = (this.timesheet?.payments || []).length;
      const nextIndex = rowIndex + direction;

      if (nextIndex >= 0 && nextIndex < total) {
        this.$nextTick(() => this.focusDay(timesheetId, nextIndex));
        return;
      }

      if (direction === 1) {
        // After last payday input → first checkbox
        this.$nextTick(() => this.focusTarget('retentionCheckbox'));
        return;
      }

      // Before first payday input → ordered navigation backward
      this.$nextTick(() => this.navigate(direction));
    },

    // Generic key handling for checkboxes/buttons
    handleGenericKeydown(e) {
      let direction = null;
      switch (e.key) {
        case 'Tab': direction = e.shiftKey ? -1 : 1; break;
        case 'ArrowRight':
        case 'ArrowDown': direction = 1; break;
        case 'ArrowLeft':
        case 'ArrowUp': direction = -1; break;
        default: return; // let Enter/Space click
      }
      e.preventDefault();
      this.navigate(direction);
    },

    validateRow(index) {
      // optional row-level re-validation
    },

    async submitForm(event, validateFn) {
      this.saving = true;
      const isValid = await validateFn();
      if (isValid) {
        const isSubmit = event.submitter.name === 'submit';
        const payments = this.timesheet.payments.map(p => ({
          id: p.id,
          amount: p.amount,
          absence_type: p.absence_type,
          descriptions: this.descriptions
              .filter(d => d.payment_id === p.id)
              .map(d => ({
                id: d.id ?? null,
                description: d.description?.trim() || ''
              }))
        }));
        const payload = {
          retention_released: this.timesheet.retention_released,
          back_next_week: this.timesheet.back_next_week,
          submit: isSubmit,
          additions_deductions: [
            ...this.pre_additions,
            ...this.post_additions,
            ...this.pre_deductions,
            ...this.post_deductions
          ],
          descriptions: [...this.descriptions],
          payments
        };

        await axios.post(`${this.crmApiPath}r3/admin/timesheets/company/${this.company_id}/timesheets/${this.timesheet_id}`, payload);
        await this.fetchTimesheet();

        if(isSubmit){
          await this.$router.push({
            name: 'a_timesheet_r2_select_site_worker',
            query: { timesheet: this.timesheet_id },
            params: {
              company_id: this.company_id,
              start_date: this.start_date,
              end_date: this.end_date,
              order_id: this.order_id,
              order_job_id: this.order_job_id
            }
          });
        }
      } else {
        alert('Please complete all required fields.');
      }
      this.saving = false;
    }
  }
};
</script>
